export default __webpack_public_path__ + "static/shutterstock_4-cfe1b2344d61301aec11fc6f379bfbbe.jpg";